/**
 * @flow weak
 */

export const UPDATE_INVOICE_FIELD = 'UPDATE_INVOICE_FIELD';
export const GENERATE_INVOICE = 'GENERATE_INVOICE';
export const GENERATE_INVOICE_SUCCESS = 'GENERATE_INVOICE_SUCCESS';
export const GENERATE_INVOICE_ERROR = 'GENERATE_INVOICE_ERROR';

export const updateInput = (input: string, value: string) => {
  return {
    type: UPDATE_INVOICE_FIELD,
    payload: {
      input,
      value
    }
  };
};

export const generateInvoice = () => {
  return {
    type: GENERATE_INVOICE
  };
};



// WEBPACK FOOTER //
// ./src/modules/invoice/actions.js